import { Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsDateString,
  IsInt,
  IsOptional,
  IsString
} from 'class-validator';

export class UsersSummeryQueryParamsDto {
  @Type(() => String)
  @Transform(({ value }) => value?.split(','))
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  fieldTypes?: string[];

  @Type(() => String)
  @Transform(({ value }) => value?.split(','))
  @IsOptional()
  @IsArray()
  inspectionTypes?: string[];

  @Type(() => String)
  @Transform(({ value }) => value?.split(','))
  @IsOptional()
  @IsArray()
  assignees?: string[];

  @Type(() => String)
  @Transform(({ value }) => value?.split(','))
  @IsOptional()
  @IsArray()
  statuses?: string[];

  @Type(() => String)
  @Transform(({ value }) => value?.split(','))
  @IsOptional()
  @IsArray()
  conclusion?: string[];

  @Type(() => Number)
  @IsOptional()
  @IsInt()
  companyId?: number;

  @IsDateString()
  @IsOptional()
  createdAtFrom?: string;

  @IsDateString()
  @IsOptional()
  createdAtTo?: string;

  @IsDateString()
  @IsOptional()
  updatedAtFrom?: string;

  @IsDateString()
  @IsOptional()
  updatedAtTo?: string;

  @IsDateString()
  @IsOptional()
  statusUpdatedAtFrom?: string;

  @IsDateString()
  @IsOptional()
  statusUpdatedAtTo?: string;

  @IsDateString()
  @IsOptional()
  icountOrderLastUpdatedFrom?: string;

  @IsDateString()
  @IsOptional()
  icountOrderLastUpdatedTo?: string;

  @IsDateString()
  @IsOptional()
  inspectionDateFrom?: string;

  @IsDateString()
  @IsOptional()
  inspectionDateTo?: string;
}
